import { ITerritorialUnit } from 'APIPackage/CatalogsModule/interfaces/ITerritorialUnit';

import { IAnalyticsTerritorialUnitSelectOption } from '../interfaces/IAnalyticsTerritorialUnitSelectOption';

export const createAnalyticsTerritoryUnitsSelectOption = (
  territorialUnit: ITerritorialUnit,
): IAnalyticsTerritorialUnitSelectOption => ({
  ...territorialUnit,
  label: territorialUnit.value,
  value: territorialUnit.value,
});
